<template>
  <div class="coupon-list">
    <div class="coupon-item" v-for="(item, index) in couponList" :key="index">
      <div class="coupon-left">
        <div class="money"><span>¥</span>{{formatMoney(item.batchMoney)}}</div>
      </div>
      <div class="coupon-right">
        <div class="title">{{item.showTitle}}</div>
        <div class="divide" v-if="item.startTime">—&nbsp; &nbsp;有效期&nbsp;&nbsp;—</div>
        <div class="time">{{formatTime(item.startTime, item.endTime)}}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['couponList'],
  methods: {
    formatMoney (money) {
      return money.toFixed(1)
    },
    formatTime (startTime, endTime) {
      if (startTime) {
        const reg = /-/g
        const str1 = startTime.replace(reg, '.').slice(2)
        const str2 = endTime.replace(reg, '.').slice(2)
        return `${str1}-${str2}`
      }
      return null
    }
  }
}
</script>
<style lang='scss' scoped>
.coupon-list {
  display: flex;
  flex-wrap: wrap;
}
.coupon-item {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  margin: 10px 1%;
  width: 48%;
  padding-left: 5px;
}
.coupon-left {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 61px;
  height: 68px;
  background: url('../../assets/images/savecoupon/left.png');
  background-size: 100% 100%;
  color: #e04728;
  flex-shrink: 0.6;
  .money {
    font-size: 18px;
    font-weight: 600;
    max-width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: center;
    span {
      font-size: 12px;
    }
  }
}
.coupon-right {
  flex-shrink: 1.4;
  position: relative;
  left: -10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 92px;
  height: 68px;
  padding-left: 12px;
  background: url('../../assets/images/savecoupon/right.png');
  background-size: 100% 100%;
  color: #fff;
  font-size: 12px;
  line-height: 1.4;
  .title {
    font-size: 13px;
    text-align: center;
    margin-left: -1px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .divide {
    margin-left: -5px;
    transform: scale(0.9);
    text-align: center;
  }
  .time {
    white-space: nowrap;
    transform: scale(0.82);
    text-align: left;
    margin-left: -6px;
  }
}
</style>
